// extracted by mini-css-extract-plugin
export default {"title":"PopularDoctors_title__iVZMZ","container":"PopularDoctors_container__i-Fko","timelineTitle":"PopularDoctors_timelineTitle__qjSMP"};